import {observer} from "mobx-react";
import {ModalBody} from "@/components/modal/index";
import styled from "styled-components";
import Button from "@/components/common/Button";
import {
    ButtonWrap,
    FileUploadArea,
    ImportInfo,
    RequiredStar,
    TitleContentInner,
    TitleContentWrap
} from "@/styles/CommonStyle";
import React, {useEffect, useRef} from "react";
import SelectBox from "@/components/common/SelectBox";
import Input from "@/components/common/Input"
import {fileUpload, setToast} from "@/utils";
import {BsPaperclip} from "react-icons/bs";
import {IoCloseCircleOutline} from "react-icons/io5";
import {useStore} from "@/store";
import {getCurrentNode} from "@/utils/menu";

const PartnersAddModal = observer(({data, menuId, handleCloseModal, modalDepth, confirmFunc}) => {
    const {boardDetailStore, menuStore} = useStore();
    useEffect(() => {
        boardDetailStore.setBoardFormDataReset();
        if(data){
            boardDetailStore.setCooperationInnerData(data);
        }
    }, [data])
    const hideFiles = useRef(null);
    const setFileUpload = () => {
        hideFiles.current.click();
    }
    return(
        <ModalBody>
            <PartnersAddModalWrap>
                <TitleContentWrap className={"filter-search-wrap"}>
                    <TitleContentInner className={"cooperation-title"}>
                        <div className={"title"}>회사명<RequiredStar>*</RequiredStar></div>
                        <div className={"content"}>
                            <Input
                                inputType="text"
                                placeholder="입력해주세요"
                                width={"fill"}
                                value={boardDetailStore.listInnerData?.["title"]}
                                onChange={(e) => {
                                    boardDetailStore.setCooperationDataList("title", e.target.value)
                                }}
                            />
                        </div>
                    </TitleContentInner>

                    <TitleContentInner>
                        <div className={"title"}>설명내용<RequiredStar>*</RequiredStar></div>
                        <div className={"content"}>
                            <div className={"textarea-content-wrap"}>
                            <textarea
                                placeholder={"내용을 입력해주세요."}
                                value={boardDetailStore.listInnerData?.["contents"]}
                                onChange={(e) => {
                                    boardDetailStore.setCooperationDataList("contents", e.target.value);
                                }}
                            />
                            </div>
                        </div>
                    </TitleContentInner>
                    <TitleContentInner>
                        <div className={"title"}>연결링크<RequiredStar>*</RequiredStar></div>
                        <div className={"content"}>
                            <Input
                                inputType="text"
                                placeholder="홈페이지 주소를 입력해주세요"
                                width={"fill"}
                                value={boardDetailStore.listInnerData?.["connectUrl"]}
                                onChange={(e) => {
                                    boardDetailStore.setCooperationDataList("connectUrl", e.target.value);
                                }}
                            />
                        </div>
                    </TitleContentInner>
                    <TitleContentInner>
                        <div className={"title"}>로고파일<RequiredStar>*</RequiredStar></div>
                        <div className={"content"}>
                            <FileUploadArea className={"view-img"}>
                                <div className={"file-wrap"}
                                     onClick={setFileUpload}
                                >
                                    <input
                                        className={"file-hide-input"}
                                        ref={hideFiles}
                                        type="file"
                                        multiple
                                        accept=".jpg,.jpeg,.png,.gif"
                                        onChange={(e) =>
                                            fileUpload(e, {
                                                prevFiles: boardDetailStore.formFile,
                                                onAfter: boardDetailStore.setFormFilesData,
                                                maxSizeMB: parseInt(boardDetailStore.currentBoardContent.options.file.size.split("MB")[0]),
                                                multiple: true,
                                                maxFiles: boardDetailStore.currentBoardContent.options.file.count,
                                                type: "admin",
                                                accepts: [".jpg", ".jpeg", ".png", ".gif"],
                                            })
                                        }
                                    />
                                    <div className={"file-input-wrap"}>
                                        <Input
                                            inputType="text"
                                            placeholder="jpg, jpeg .png, gif"
                                            width={"fill"}
                                            readOnly={true}
                                        />
                                        <div className={"file-search-btn"}>
                                            <BsPaperclip size={24} color="#999"/>
                                        </div>
                                    </div>
                                </div>
                                <ImportInfo className={"mg"}>*로고 파일 넓이: 200px, 높이: 80px로 업로드 해 주세요.</ImportInfo>
                                {/*{boardDetailStore.formFile && boardDetailStore.formFile.length > 0 && (*/}
                                {/*    <div className={"file-list-info"}>*/}
                                {/*        {boardDetailStore.formFile.map((item, idx) => (*/}
                                {/*            <div className={"file-item-wrap"} key={idx}>*/}
                                {/*                <div*/}
                                {/*                    className={"cancel-btn"}*/}
                                {/*                    onClick={() => boardDetailStore.setRemoveFormFile(idx)}*/}
                                {/*                >*/}
                                {/*                    <IoCloseCircleOutline size={20} color={"#999"}/>*/}
                                {/*                </div>*/}
                                {/*                <div className={"file-item-name"}*/}
                                {/*                     onClick={async () => {*/}
                                {/*                         let file = item;*/}
                                {/*                         if (typeof item === "string") {*/}
                                {/*                             file = JSON.parse(item);*/}
                                {/*                         }*/}
                                {/*                         const url = file.path;*/}
                                {/*                         if (!url) return;*/}
                                {/*                         const name = file.name || "";*/}
                                {/*                         const targetForCheck = (name || url).toLowerCase();*/}
                                {/*                         const isImage = /\.(png|jpe?g|gif|webp|bmp|svg)$/.test(targetForCheck);*/}
                                {/*                         const isPdf = /\.pdf$/.test(targetForCheck);*/}
                                {/*                         if (isImage || isPdf) {*/}
                                {/*                             // 이미지 또는 PDF → 새창 열기*/}
                                {/*                             window.open(url, "_blank", "noopener,noreferrer");*/}
                                {/*                         } else {*/}
                                {/*                             await downloadFile(file.path, file.name);*/}
                                {/*                         }*/}
                                {/*                     }}*/}
                                {/*                >{item.name}</div>*/}
                                {/*            </div>*/}
                                {/*        ))}*/}
                                {/*    </div>*/}
                                {/*)}*/}
                                {boardDetailStore.formFile &&
                                    boardDetailStore.formFile.length > 0 && (
                                        <div className={"file-list-info"}>
                                            {boardDetailStore.formFile.map((item, idx) => {
                                                const src = boardDetailStore.imagePreviewMap[idx];
                                                return (
                                                    <div className={"file-item-wrap"} key={idx}>
                                                        <div
                                                            className={"cancel-btn"}
                                                            onClick={() => boardDetailStore.setRemoveFormFile(idx)}
                                                        >
                                                            <IoCloseCircleOutline size={20} color={"#999"} />
                                                        </div>
                                                        {src ? (
                                                            <img
                                                                className="file-item-image"
                                                                src={src}
                                                                alt={item?.name || `banner-${idx}`}
                                                            />
                                                        ) : (
                                                            <div className="file-item-fallback">
                                                                미리보기를 불러올 수 없습니다.
                                                            </div>
                                                        )}
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    )}
                            </FileUploadArea>
                        </div>
                    </TitleContentInner>
                    <TitleContentInner>
                        <div className={"title"}>공개유무<RequiredStar>*</RequiredStar></div>
                        <div className={"content"}>
                            <div className={"is-active-wrap"}>
                                <SelectBox
                                    option={IS_ACTIVE_LIST}
                                    size="m"
                                    type="solid"
                                    round={true}
                                    placeholder="선택"
                                    onChange={async (e) => {
                                        boardDetailStore.setCooperationDataList("isActive", e.value);
                                    }}
                                    value={IS_ACTIVE_LIST.find(opt => opt.value === boardDetailStore.listInnerData?.["isActive"]) || null}
                                />
                            </div>
                        </div>
                    </TitleContentInner>
                </TitleContentWrap>
                <ButtonWrap className={"center cooperation-btn-wrap"} $gap={10}>
                    <Button
                        type="solid"
                        size="m"
                        round={true}
                        text={"취소"}
                        onClickFunc={async () => {
                            handleCloseModal(modalDepth);
                        }}
                    />
                    <Button
                        type="fill"
                        size="m"
                        round={true}
                        text={`${data ? "수정" : "등록"}`}
                        onClickFunc={async () => {
                            if(!boardDetailStore.listInnerData?.["title"]){
                                setToast("warning", "회사명을 입력해 주세요.");
                                return;
                            }
                            // contents connectUrl
                            if(!boardDetailStore.listInnerData?.["contents"]){
                                setToast("warning", "설명내용을 입력해 주세요.");
                                return;
                            }

                            if(!boardDetailStore.listInnerData?.["connectUrl"]){
                                setToast("warning", "연결링크을 입력해 주세요.");
                                return;
                            }
                            if(boardDetailStore.formFile?.length <= 0){
                                setToast("warning", "로고파일을 업로드해주세요..");
                                return;
                            }
                            if(!boardDetailStore.listInnerData?.["isActive"]){
                                setToast("warning", "공개유무를 선택해 해주세요.");
                                return;
                            }
                            try {
                                const root = getCurrentNode(menuStore.menuTreeList, menuId)?.trail[0];
                                const response =  await boardDetailStore.setBoardFormData(menuId, data, "partners", root.menuId);
                                if(response){
                                    boardDetailStore.setBoardFormDataReset();
                                    setToast("success", "등록 되었습니다.")
                                    confirmFunc();
                                }
                            } catch (e) {

                            }
                        }}
                    />
                </ButtonWrap>
            </PartnersAddModalWrap>
        </ModalBody>
    )
});
const PartnersAddModalWrap = styled.div`

    .textarea-content-wrap{
        width: 100%;
        height: 200px;
        textarea{
            width: 100%;
            height: 100%;
            border-radius: 8px;
            border: 2px solid #D1D1D1;
            padding: 14px;
            color: #333333;
            font-size: 16px;
            font-weight: 400;
            resize: none;
            outline: none;
        }
    }
    .is-active-wrap {
        width: 150px;

        .react-select__menu {
            width: 100%;
        }
    }

    
    .cooperation-btn-wrap {
        margin-top: 24px;
    }
`
export default PartnersAddModal;
const IS_ACTIVE_LIST = [
    {label: "공개", value: "active"},
    {label: "비공개", value: "hidden"},
]


